import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { MdAirplanemodeActive, MdTrain } from "react-icons/md";
import { FaCar } from "react-icons/fa6";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";

const AirportTransferCardImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/airport-transfer-card.png";
const AlphardImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/services/alphard.png";

export const AirportTransfer = () => {
  const { push } = useHistory();
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  return (
    <div className="tw:lg:px-[82px]">
      <div className="tw:px-5 tw:lg:px-0 tw:mt-7 tw:lg:mt-[54px]">
        <div className="tw:flex tw:flex-col tw:lg:flex-row tw:rounded-[10px] tw:overflow-hidden">
          <img
            src={AirportTransferCardImage}
            alt="Airport Transfer Card"
            className="tw:w-full tw:h-[300px] tw:lg:h-[260px] tw:lg:min-w-[452px] tw:object-cover tw:rounded-t-[10px] tw:lg:rounded-none tw:flex-1"
          />
          <div className="tw:bg-[#F9F9F9]">
            <div className="tw:px-[25px] tw:lg:px-[48px] tw:pt-8 tw:lg:pt-[46px] tw:pb-7 tw:lg:pb-[46px] tw:space-y-[10px]">
              <div className="tw:pb-4 tw:border-b tw:border-b-[#F1F1F1] tw:mb-4">
                <div className="tw:font-semibold tw:text-[#282828] tw:tracking-[3px] tw:text-[8px] tw:font-hanken-grotesk tw:uppercase">
                  {t(`Service.AirportTransfer.Title`)}
                </div>
                <div className="tw:text-[#282828] tw:font-libre-caslon-display tw:text-[26px] tw:lg:text-[45px] tw:leading-[35px] tw:lg:leading-[58px]">
                  {t(`Service.AirportTransfer.Title`)}
                </div>
              </div>
              <div
                className={cn(
                  "tw:text-[#4E4E4E] tw:font-hanken-grotesk",
                  getTypographyClass(13),
                  getTypographyClass(14, "lg")
                )}
              >
                {t(`Service.AirportTransfer.Description`)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tw:mt-8 tw:lg:mt-[54px] tw:px-5 tw:lg:px-0 tw:font-libre-caslon-display tw:leading-[23px] tw:lg:leading-[26px] tw:lg:text-[22px] tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1]">
        <div>{t(`Service.AirportTransfer.Quote1`)}</div>
        <div>{t(`Service.AirportTransfer.Quote2`)}</div>
      </div>

      {/* Airport Pickup & Meet-and-Greet Service */}
      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          <div>{t(`Service.AirportTransfer.AirportPickup.Title`)}</div>
        </div>
        <div>
          <div>
            <div
              className={cn(
                "tw:mt-5 tw:lg:mt-0",
                getTypographyClass(13),
                getTypographyClass(14, "lg")
              )}
            >
              <div>
                <Trans
                  i18nKey={`Service.AirportTransfer.AirportPickup.Description1`}
                  components={{
                    strong: <strong></strong>,
                  }}
                />
              </div>
            </div>
            <div className="tw:mt-5 tw:lg:mt-[26px] tw:flex tw:gap-x-[10px]">
              <div className="tw:flex-1 tw:px-[14px] tw:lg:px-4 tw:py-5 tw:lg:py-0 tw:lg:h-[50px] tw:flex tw:items-center tw:border tw:border-[#D9D9D9] tw:rounded-[5px] tw:gap-x-3 tw:justify-start tw:lg:justify-between tw:cursor-pointer"
                onClick={() => push(t(`Service.AirportTransfer.AirportPickup.RedirectLink.HanedaAirport`))}>
                <div className="tw:space-y-3 tw:lg:space-y-0 tw:space-x-0 tw:lg:space-x-2 tw:block tw:lg:flex tw:lg:items-center">
                  <MdAirplanemodeActive color="#4E4E4E" size={20} />
                  <div
                    className={cn(
                      "text-[#4E4E4E] tw:font-bold",
                      getTypographyClass(13)
                    )}
                  >
                    {t(
                      `Service.AirportTransfer.AirportPickup.HanedaAirportPickup`
                    )}
                  </div>
                </div>
                <div>
                  <FiArrowRight size={20} color="#C9C9C9" />
                </div>
              </div>
              <div className="tw:flex-1 tw:px-[14px] tw:lg:px-4 tw:py-5 tw:lg:py-0 tw:lg:h-[50px] tw:flex tw:items-center tw:border tw:border-[#D9D9D9] tw:rounded-[5px] tw:gap-x-3 tw:justify-start tw:lg:justify-between tw:cursor-pointer"
                onClick={() => push(t(`Service.AirportTransfer.AirportPickup.RedirectLink.NaritaAirport`))}>
                <div className="tw:space-y-3 tw:lg:space-y-0 tw:space-x-0 tw:lg:space-x-2 tw:block tw:lg:flex tw:lg:items-center">
                  <MdAirplanemodeActive color="#4E4E4E" size={20} />
                  <div
                    className={cn(
                      "text-[#4E4E4E] tw:font-bold",
                      getTypographyClass(13)
                    )}
                  >
                    {t(
                      `Service.AirportTransfer.AirportPickup.NaritaAirportPickup`
                    )}
                  </div>
                </div>
                <div>
                  <FiArrowRight size={20} color="#C9C9C9" />
                </div>
              </div>
            </div>
          </div>
          <div
            className={cn(
              "tw:mt-5 tw:lg:mt-[26px] tw:font-hanken-grotesk tw:text-[#282828]",
              getTypographyClass(13)
            )}
          >
            <Trans
              i18nKey={`Service.AirportTransfer.AirportPickup.Description2`}
              components={{
                strong: <strong></strong>,
              }}
            />
            <div className="tw:mt-5 tw:lg:mt-[26px] tw:flex tw:gap-x-[10px]">
              <div className="tw:flex-1 tw:px-[14px] tw:lg:px-4 tw:py-5 tw:lg:py-0 tw:lg:h-[50px] tw:flex tw:items-center tw:border tw:border-[#D9D9D9] tw:rounded-[5px] tw:gap-x-3 tw:justify-start tw:lg:justify-between tw:cursor-pointer"
                onClick={() => push(t(`Service.AirportTransfer.AirportPickup.RedirectLink.TokyoStation`))}>
                <div className="tw:space-y-3 tw:lg:space-y-0 tw:space-x-0 tw:lg:space-x-2 tw:block tw:lg:flex tw:lg:items-center">
                  <MdTrain color="#4E4E4E" size={20} />
                  <div
                    className={cn(
                      "text-[#4E4E4E] tw:font-bold",
                      getTypographyClass(13)
                    )}
                  >
                    {t(`Service.AirportTransfer.AirportPickup.TokyoStation`)}
                  </div>
                </div>
                <div>
                  <FiArrowRight size={20} color="#C9C9C9" />
                </div>
              </div>
              <div className="tw:flex-1 tw:px-[14px] tw:lg:px-4 tw:py-5 tw:lg:py-0 tw:lg:h-[50px] tw:flex tw:items-center tw:border tw:border-[#D9D9D9] tw:rounded-[5px] tw:gap-x-3 tw:justify-start tw:lg:justify-between tw:cursor-pointer"
                onClick={() => push(t(`Service.AirportTransfer.AirportPickup.RedirectLink.ShinagawaStation`))}>
                <div className="tw:space-y-3 tw:lg:space-y-0 tw:space-x-0 tw:lg:space-x-2 tw:block tw:lg:flex tw:lg:items-center">
                  <MdTrain color="#4E4E4E" size={20} />
                  <div
                    className={cn(
                      "text-[#4E4E4E] tw:font-bold",
                      getTypographyClass(13)
                    )}
                  >
                    {t(
                      `Service.AirportTransfer.AirportPickup.ShinagawaStation`
                    )}
                  </div>
                </div>
                <div>
                  <FiArrowRight size={20} color="#C9C9C9" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Meet & Assist Service */}
      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.AirportTransfer.MeetAssistService.Title")}
        </div>
        <div
          className={cn(
            "tw:mt-5 tw:lg:mt-0",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey="Service.AirportTransfer.MeetAssistService.Description"
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
      </div>

      {/* Corporate Welcome Options */}
      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.AirportTransfer.CorporateWelcomeOptions.Title")}
        </div>
        <div
          className={cn(
            "tw:mt-5 tw:lg:mt-0",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey="Service.AirportTransfer.CorporateWelcomeOptions.Description"
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
      </div>

      {/* Vehicle Comfort & Amenities */}
      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.AirportTransfer.VehicleComfortAmenities.Title")}
        </div>
        <div
          className={cn(
            "tw:mt-5 tw:lg:mt-0",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey="Service.AirportTransfer.VehicleComfortAmenities.Description"
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
        <div className="tw:mt-5">
          <div className="tw:px-[45px]">
            <img src={AlphardImage} alt="Alphard" className="" />
          </div>
          <Link to={i18n.language === "en" || i18n.language === "EN" ? "/en/fleet" : "/jp/fleet"} className="tw:!no-underline">
            <div className="tw:rounded-md tw:h-[50px] tw:px-4 tw:flex tw:justify-between tw:items-center tw:border tw:border-[#D9D9D9]">
              <div className="tw:flex tw:items-center tw:gap-x-2">
                <FaCar size={20} color="#4E4E4E" />
                <div
                  className={cn(
                    "tw:text-[#4E4E4E] tw:font-bold",
                    getTypographyClass(13)
                  )}
                >
                  {t("OurFleets")}
                </div>
              </div>
              <div>
                <FiArrowRight size={20} color="#C9C9C9" />
              </div>
            </div>
          </Link>
        </div>
      </div>

      {/* Multi-lingual Chauffeur Support */}
      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.AirportTransfer.MultilingualSupport.Title")}
        </div>
        <div
          className={cn(
            "tw:mt-5 tw:lg:mt-0",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey="Service.AirportTransfer.MultilingualSupport.Description"
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
      </div>

      {/* Commitment to Seamless Service */}
      <div className="tw:px-5 tw:lg:px-0 tw:mt-8 tw:lg:mt-[54px] tw:font-hanken-grotesk tw:pb-8 tw:lg:pb-[54px] tw:border-b tw:border-b-[#F1F1F1] tw:text-[#282828] tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-x-[69px]">
        <div className="tw:font-medium tw:lg:font-semibold tw:lg:text-[18px] tw:lg:leading-[25px] tw:lg:min-w-[200px] tw:lg:w-[200px]">
          {t("Service.AirportTransfer.CommitmentToSeamlessService.Title")}
        </div>
        <div
          className={cn(
            "tw:mt-5 tw:lg:mt-0",
            getTypographyClass(13),
            getTypographyClass(14, "lg")
          )}
        >
          <Trans
            i18nKey="Service.AirportTransfer.CommitmentToSeamlessService.Description"
            components={{
              strong: <strong></strong>,
            }}
          />
        </div>
      </div>
    </div>
  );
};
